<app-card class="flex-basis-100 mb-12">
  <div cardTitle i18n>Information du contrat</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="metadata?.birthDate || originalMetadata?.birthDate"
      >
        <span class="card__label" i18n>Date de naissance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata?.birthDate,
            }"
            >{{ metadata.birthDate }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.birthDate &&
              originalMetadata?.birthDate !== metadata.birthDate
            "
            >{{ originalMetadata.birthDate }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.startDate || originalMetadata?.startDate"
      >
        <span class="card__label" i18n>Date d'effet</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.startDate,
            }"
            >{{ metadata.startDate }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.startDate &&
              originalMetadata?.startDate !== metadata.startDate
            "
            >{{ originalMetadata.startDate }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.childrenCount != undefined ||
          originalMetadata?.childrenCount != undefined
        "
      >
        <span class="card__label" i18n>Nombre d'enfants</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.childrenCount,
            }"
            >{{ metadata.childrenCount }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.childrenCount &&
              originalMetadata?.childrenCount !== metadata.childrenCount
            "
            >{{ originalMetadata.childrenCount }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.civilLiability || originalMetadata?.civilLiability"
      >
        <span class="card__label" i18n>Responsabilité civile</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.civilLiability,
            }"
            >{{ getHouseholdLiabilityLabel(metadata.civilLiability) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.civilLiability &&
              originalMetadata?.civilLiability !== metadata.civilLiability
            "
            >{{
              getHouseholdLiabilityLabel(originalMetadata.civilLiability)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.deductible || originalMetadata?.deductible"
      >
        <span class="card__label" i18n>Franchise</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.deductible,
            }"
            >{{ metadata.deductible }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.deductible &&
              originalMetadata?.deductible !== metadata.deductible
            "
            >{{ originalMetadata.deductible }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.covers?.length! > 0 || originalMetadata?.covers?.length! > 0
        "
      >
        <span class="card__label" i18n>Couvertures souhaitées</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                !(metadata?.covers || metadata?.covers?.length === 0),
            }"
          >
            <ng-container
              *ngFor="let prestation of metadata?.covers; let last = last"
              >{{ getHouseholdCoversLabel(prestation)
              }}<ng-container *ngIf="!last">,</ng-container></ng-container
            >
          </span>
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.covers &&
              !compareArrays(metadata?.covers!, originalMetadata?.covers!)
            "
            ><ng-container
              *ngFor="
                let prestation of originalMetadata?.covers;
                let last = last
              "
              >{{ getHouseholdCoversLabel(prestation)
              }}<ng-container *ngIf="!last">,</ng-container></ng-container
            ></span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          metadata?.ownershipConditions || originalMetadata?.ownershipConditions
        "
      >
        <span class="card__label" i18n>Condition de propriété</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.ownershipConditions,
            }"
            >{{
              getOwnershipConditionLabel(metadata.ownershipConditions)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.ownershipConditions &&
              originalMetadata?.ownershipConditions !==
                metadata.ownershipConditions
            "
            >{{
              getOwnershipConditionLabel(originalMetadata.ownershipConditions)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.adultCount != undefined ||
          originalMetadata?.adultCount != undefined
        "
      >
        <span class="card__label" i18n>Nombre d'adultes</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.adultCount,
            }"
            >{{ metadata.adultCount }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.adultCount &&
              originalMetadata?.adultCount !== metadata.adultCount
            "
            >{{ originalMetadata.adultCount }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.dogCount != undefined ||
          originalMetadata?.dogCount != undefined
        "
      >
        <span class="card__label" i18n>Nombre de chiens</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.dogCount,
            }"
            >{{ metadata.dogCount }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.dogCount &&
              originalMetadata?.dogCount !== metadata.dogCount
            "
            >{{ originalMetadata.dogCount }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.amountToCover || originalMetadata?.amountToCover"
      >
        <span class="card__label" i18n>Montant à assurer</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.amountToCover,
            }"
            >{{ metadata.amountToCover }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.amountToCover &&
              originalMetadata?.amountToCover !== metadata.amountToCover
            "
            >{{ originalMetadata.amountToCover }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.additionalCovers?.length! > 0 ||
          originalMetadata?.additionalCovers?.length! > 0
        "
      >
        <span class="card__label" i18n
          >Couvertures supplémentaires souhaitées</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                !(
                  metadata?.additionalCovers ||
                  metadata?.additionalCovers?.length === 0
                ),
            }"
          >
            <ng-container
              *ngFor="
                let prestation of metadata?.additionalCovers;
                let last = last
              "
              >{{ getHouseholdAdditionalCoverLabel(prestation)
              }}<ng-container *ngIf="!last">,</ng-container></ng-container
            >
          </span>
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.additionalCovers &&
              !compareArrays(
                metadata?.additionalCovers!,
                originalMetadata?.additionalCovers!
              )
            "
            ><ng-container
              *ngFor="
                let prestation of originalMetadata?.additionalCovers;
                let last = last
              "
              >{{ getHouseholdAdditionalCoverLabel(prestation)
              }}<ng-container *ngIf="!last">,</ng-container></ng-container
            ></span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    displayPlaceTypeInfo(metadata?.placeType) ||
    displayPlaceTypeInfo(originalMetadata?.placeType)
  "
>
  <div cardTitle i18n>Détails du bien</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          metadata?.placeType?.houseType ||
          originalMetadata?.placeType?.houseType
        "
      >
        <span class="card__label" i18n>Type de maison</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.placeType?.houseType,
            }"
            >{{ getHouseTypeLabel(metadata?.placeType?.houseType!) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.placeType?.houseType &&
              originalMetadata?.placeType?.houseType !==
                metadata.placeType?.houseType
            "
            >{{
              getHouseTypeLabel(originalMetadata?.placeType?.houseType!)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.placeType?.amountToCover! >= 0 ||
          originalMetadata?.placeType?.amountToCover! >= 0
        "
      >
        <span class="card__label" i18n>Somme d'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata?.placeType?.amountToCover,
            }"
            >{{ metadata?.placeType?.amountToCover }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.placeType?.amountToCover &&
              originalMetadata?.placeType?.amountToCover !==
                metadata?.placeType?.amountToCover
            "
            >{{ originalMetadata?.placeType?.amountToCover }}</span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          metadata?.placeType?.buildingType ||
          originalMetadata?.placeType?.buildingType
        "
      >
        <span class="card__label" i18n>Type de bâtiment</span>
        <div
          class="d-flex gap-2 flex-column card__value"
          *ngIf="
            metadata?.placeType?.buildingType ||
            originalMetadata?.placeType?.buildingType
          "
        >
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.placeType?.buildingType,
            }"
            *ngIf="metadata?.placeType?.buildingType"
            >{{
              getHouseholdBuildingTypeLabel(metadata?.placeType?.buildingType!)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.placeType?.buildingType &&
              originalMetadata?.placeType?.buildingType !==
                metadata.placeType?.buildingType
            "
            >{{
              getHouseholdBuildingTypeLabel(
                originalMetadata?.placeType?.buildingType!
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.placeType?.address || originalMetadata?.placeType?.address
        "
      >
        <span class="card__label" i18n>Adresse du bien</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            *ngIf="metadata?.placeType?.address"
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                !(
                  originalMetadata.placeType?.address &&
                  originalMetadata.placeType?.postalCode
                ),
            }"
            >{{ metadata.placeType.address
            }}<ng-container
              *ngIf="
                metadata.placeType?.address && metadata.placeType?.postalCode
              "
              >,</ng-container
            >
            {{ metadata.placeType.postalCode }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.placeType?.address &&
              originalMetadata?.placeType?.address !==
                metadata.placeType?.address &&
              originalMetadata?.placeType?.postalCode !==
                metadata.placeType?.postalCode
            "
            >{{ originalMetadata.placeType.address
            }}<ng-container
              *ngIf="
                originalMetadata.placeType?.address &&
                originalMetadata.placeType?.postalCode
              "
              >,</ng-container
            >
            {{ originalMetadata.placeType.postalCode }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    displayQuestionnaire(metadata) || displayQuestionnaire(originalMetadata)
  "
>
  <div cardTitle i18n>Questionnaire</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          (metadata?.sufferedClaims !== null &&
            metadata?.sufferedClaims !== undefined) ||
          (originalMetadata?.sufferedClaims !== null &&
            originalMetadata?.sufferedClaims !== undefined)
        "
      >
        <span class="card__label" i18n
          >A-t-il subi des sinistres dans les branches proposées ?</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.sufferedClaims === null ||
                  originalMetadata.sufferedClaims === undefined),
            }"
            >{{ getBooleanLabel(metadata.sufferedClaims) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.sufferedClaims &&
              originalMetadata?.sufferedClaims !== metadata.sufferedClaims
            "
            >{{ getBooleanLabel(originalMetadata.sufferedClaims) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.propositionRefused !== null &&
            metadata?.propositionRefused !== undefined) ||
          (originalMetadata?.propositionRefused !== null &&
            originalMetadata?.propositionRefused !== undefined)
        "
      >
        <span i18n class="card__label"
          >Une proposition d'assurance pour les branches proposées lui a-t-elle
          été refusée ou l'acceptation/la poursuite du contrat était-elle
          conditionnée à des conditions aggravées ?</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.propositionRefused === null ||
                  originalMetadata.propositionRefused === undefined),
            }"
            >{{ getBooleanLabel(metadata.propositionRefused) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.propositionRefused &&
              originalMetadata?.propositionRefused !==
                metadata.propositionRefused
            "
            >{{ getBooleanLabel(originalMetadata.propositionRefused) }}</span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          (metadata?.wasInsured !== null &&
            metadata?.wasInsured !== undefined) ||
          (originalMetadata?.wasInsured !== null &&
            originalMetadata?.wasInsured !== undefined)
        "
      >
        <span class="card__label" i18n
          >Est-il ou a-t-il par le passé été assuré pour les branches
          proposées ?</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.wasInsured === null ||
                  originalMetadata.wasInsured === undefined),
            }"
            >{{ getBooleanLabel(metadata.wasInsured) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.wasInsured &&
              originalMetadata?.wasInsured !== metadata.wasInsured
            "
            >{{ getBooleanLabel(originalMetadata.wasInsured) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.policyNumber || originalMetadata?.policyNumber"
      >
        <span class="card__label" i18n>Numéro de police</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.policyNumber,
            }"
            >{{ metadata?.policyNumber }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.policyNumber &&
              originalMetadata?.policyNumber !== metadata.policyNumber
            "
            >{{ originalMetadata?.policyNumber }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.oldCompany || originalMetadata?.oldCompany"
      >
        <span class="card__label" i18n>Compagnie d'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.oldCompany,
            }"
            >{{ metadata?.oldCompany }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.oldCompany &&
              originalMetadata?.oldCompany !== metadata.oldCompany
            "
            >{{ originalMetadata?.oldCompany }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>
